import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import APIService from '../services/APIService';
import PaddedGrid from '../components/PaddedGrid';
import { Typography, Grid, Table, TableHead, TableBody, TableRow, TableCell, Button, TextField, Checkbox } from '@material-ui/core';
import RestaurantAdder from '../components/RestaurantAdder';
import RestaurantType from '../constants/RestaurantType';
import AppContext from '../AppContext';
import FormatDate from '../FormatDate';
import MenuRemover from '../components/MenuRemover';
import MenuImporter from '../components/MenuImporter';
import { withTranslation } from 'react-i18next';

class Restaurants extends Component {
    constructor(props) {
        super(props);

        this.state = {
            restaurants: [],
            selectedRestaurants: [],
            search: '',
            showModal: false,
            selectAll: false
        };

        this.handleRestaurantAdded = this.handleRestaurantAdded.bind(this);
        this.filterBySearch = this.filterBySearch.bind(this);
        this.selectAll = this.selectAll.bind(this);
    }

    selectRestaurant(restaurantId, ev, forceState) {
        if (ev) {
            ev.stopPropagation();
            ev.preventDefault();
        }

        let selectedRestaurants = this.state.selectedRestaurants;
        const index = selectedRestaurants.indexOf(restaurantId);

        if (index !== -1 && forceState !== true) {
            selectedRestaurants.splice(index, 1);
        } else if (index === -1 && forceState !== false) {
            selectedRestaurants.push(restaurantId);
        }

        this.setState({selectedRestaurants});
    }

    filterBySearch() {
        if (!this.state.search || this.state.search.length < 1) {
            return this.state.restaurants;
        }

        const restaurants = this.state.restaurants.filter(restaurant => restaurant.name.toLowerCase().includes(this.state.search.toLowerCase()));
        return restaurants;
    }

    selectAll() {
        const visibleRestaurants = this.filterBySearch();
        visibleRestaurants.forEach(restaurant => this.selectRestaurant(restaurant.id, null, !this.state.selectAll));

        this.setState({selectAll: !this.state.selectAll});
    }

    handleRestaurantAdded(restaurant) {
        let restaurants = this.state.restaurants;
        restaurants.push(restaurant);
        restaurants.sort((a, b) => a.name > b.name);

        this.setState({
            restaurants,
            showModal: false
        });
    }

    componentDidMount() {
        APIService.getRestaurants()
            .then((restaurants) => {
                restaurants.sort((a, b) => a.name > b.name);
                this.setState({restaurants});
            })
            .catch((e) => AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e));
    }

    onReceiveMenus(menus) {
        console.log(menus);
    }

    render() {
        if (!AppContext.isAdmin() && !AppContext.isOrganisation())
        {
            return (<Redirect to="/"/>);
        }

        return (
            <PaddedGrid>
                <Grid item xs={12}>
                    <Typography variant="title">{this.props.t('Toimipaikat')}</Typography>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="subheading">{this.props.t('Etsi toimipaikka')}</Typography>
                    <TextField
                        fullWidth
                        label={this.props.t('Toimipaikan nimi')}
                        value={this.state.search}
                        onChange={(event) => this.setState({search: event.target.value, selectAll: false})}/>
                </Grid>
                <div style={{marginTop: '20px'}}>
                    {AppContext.isAdmin() && (
                        <Button color="primary" onClick={() => this.setState({showModal: true})}>+ {this.props.t('Lisää toimipaikka')}</Button>
                    )}
                    <Button disabled={this.state.selectedRestaurants.length < 1} onClick={() => this.setState({showImportModal: true})}>{this.props.t('Lisää ruokalista valittuihin toimipisteisiin')}</Button>
                    <Button disabled={this.state.selectedRestaurants.length < 1} onClick={() => this.setState({showRemoveModal: true})}>{this.props.t('Poista ruokalistoja valituista toimipisteistä')}</Button>
                </div>
                <Grid item xs={12}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{width: '40px'}}>
                                    <Checkbox
                                        checked={this.state.selectAll}
                                        onClick={this.selectAll}/>
                                </TableCell>
                                <TableCell>#</TableCell>
                                <TableCell>{this.props.t('Nimi')}</TableCell>
                                <TableCell>{this.props.t('Tyyppi')}</TableCell>
                                <TableCell>{this.props.t('Käyttäjätunnus')}</TableCell>
                                <TableCell>{this.props.t('Kirjausjakson alku')}</TableCell>
                                <TableCell>{this.props.t('Kirjausjakson päätös')}</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {this.filterBySearch().map(restaurant =>
                                <TableRow key={restaurant.id} component={Link} to={{
                                    pathname: `/restaurants/${restaurant.id}`,
                                    state: {restaurant}
                                }}
                                style={{textDecoration: 'none'}}
                                >
                                    <TableCell style={{width: '40px'}}>
                                        <Checkbox
                                            checked={this.state.selectedRestaurants.indexOf(restaurant.id) !== -1}
                                            onClick={(ev) => this.selectRestaurant(restaurant.id, ev)}/>
                                    </TableCell>

                                    <TableCell>{restaurant.id}</TableCell>
                                    <TableCell>{restaurant.name}</TableCell>
                                    <TableCell>{this.props.t(RestaurantType[restaurant.type])}</TableCell>
                                    <TableCell>{restaurant.user.email}</TableCell>
                                    <TableCell>{FormatDate(restaurant.reporting_period_start)}</TableCell>
                                    <TableCell>{FormatDate(restaurant.reporting_period_end)}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <MenuImporter
                        open={this.state.showImportModal}
                        restaurantId={this.state.selectedRestaurants}
                        onReceiveMenus={this.onReceiveMenus}
                        onClose={() => this.setState({showImportModal: false})}
                    />

                    <MenuRemover
                        open={this.state.showRemoveModal}
                        restaurantIds={this.state.selectedRestaurants}
                        onClose={() => this.setState({showRemoveModal: false})}
                    />

                    <RestaurantAdder
                        open={this.state.showModal}
                        onAdded={this.handleRestaurantAdded}
                        onClose={() => this.setState({showModal: false})}/>

                    <div style={{marginTop: '20px'}}>
                        {AppContext.isAdmin() && (
                            <Button color="primary" onClick={() => this.setState({showModal: true})}>+ {this.props.t('Lisää toimipaikka')}</Button>
                        )}
                        <Button disabled={this.state.selectedRestaurants.length < 1} onClick={() => this.setState({showImportModal: true})}>{this.props.t('Lisää ruokalista valittuihin toimipisteisiin')}</Button>
                        <Button disabled={this.state.selectedRestaurants.length < 1} onClick={() => this.setState({showRemoveModal: true})}>{this.props.t('Poista ruokalistoja valituista toimipisteistä')}</Button>
                    </div>
                </Grid>
            </PaddedGrid>
        );
    }
}

export default withTranslation()(Restaurants);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Restaurants.js